import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBack from '@material-ui/icons/ArrowBack';

import './Sidepanel.css';
import SelectedRoute from '../Routes/SelectedRoute';
import RouteList from '../Routes/RouteList';

class Sidepanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editMode: false,
    };
  }

  handleSelect = (type, id) => {
    this.props.onSelect(id);
  };

  resetSelected = () => {
    this.props.onSelect(null);
  };

  render() {
    const {
      data,
      activeItem,
      selected,
      onOptimize,
      stopsToOptimize,
      onEditModeChange,
      onStopClick,
      onStopRemove,
      editMode,
      selectedStop,
      highlightedRoute,
      onRouteHover
    } = this.props;

    const selectedRoute = selected && data.routes.find(item => item.id == selected);
    return (
      <div className="flex flex-column sidepanel">
        <AppBar position="static" color="secondary">
          <Toolbar className="space-between">
            <div className="flex flex-row center">
              {!selected && (
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={() => this.handleSelect(null)}
                >
                  <MenuIcon color="primary" />
                </IconButton>
              )}
              {selected && !editMode && (
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={this.resetSelected}
                >
                  <ArrowBack color="primary" />
                </IconButton>
              )}
              <Typography variant="h6" noWrap>
                {activeItem === 'home' && 'Routes'}
                {activeItem === 'route' && `Route ${selected}`}
              </Typography>
            </div>
            {!editMode && (
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={onEditModeChange}
              >
                Edit mode
              </Button>
            )}
            {editMode && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={onEditModeChange}
              >
                Back
              </Button>
            )}
            {editMode && (
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={onOptimize}
              >
                Optimize
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <div
          className={`flex flex-column grow sidepanel-content ${activeItem}`}
        >
          {selected ? (
            <SelectedRoute
              route={selectedRoute}
              selectedStopId={selectedStop}
              onStopClick={onStopClick}
              onStopRemove={onStopRemove}
              stopsToOptimize={stopsToOptimize}
            />
          ) : (
            <RouteList
              onSelect={this.handleSelect}
              data={data}
              highlightedRoute={highlightedRoute}
              onRouteHover={onRouteHover}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Sidepanel;
